import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { get } from "../Network/requests";
import { getUrl } from "../Network/urls";
import { tokenExpire } from "../Utils";
import AppContext from "../Store/AppContext";
import HeaderComponent from "./UI/HeaderComponent";
import Loader from "./UI/Loader";
import NoDataFoundComponent from "./UI/NoDataFoundComponent";
import FooterComponent from "./UI/FooterComponent";
import SidePanel from "./UI/SidePanel";
import LinearLoader from "./UI/LinearLoader";
import { TbArrowsMinimize } from "react-icons/tb";
import { LuExpand } from "react-icons/lu";
import { IoMdRefresh } from "react-icons/io";
import GridGroupIcons from "./UI/GridGroupIcons";
import { CircularProgress } from "@mui/material";
// import fetchProducts from './HeaderComponent';

function Settings() {
  const navigate = useNavigate();
  const {
    clientDetails,
    handleDataEncryption,
    encryptedClientValuesObj,
    handleEncryptOtherParamsOfAPI,
    handleDecryptResponse,
    handleAPIEncryptValue,
    // handleDecryptedValue,
    // handleDataDecryption,
    setClientDetails,
    handleGetDecryptedData,
    handleDataDecryption,
    inputBucketName,
    setInputBucketName,
  } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [filesData, setFilesData] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isAuthenticated, setisAuthenticated] = useState(true);
  // let clientDetails = JSON.parse(localStorage.getItem('clientDetails'));

  const [clientName, setClientName] = useState({});
  let [clientId, setClientId] = useState("");
  const clientRole = `${clientDetails?.role}`;
  let optionList = [];
  let clientidname = [];
  const [showComponent, setShowComponent] = useState(false);

  const getUsers = () => {
    setIsLoading(true);
    if (clientRole !== "Admin") {
      setisAuthenticated(false);
    }
    const url = getUrl("fetch-user");
    const data = {
      client_id: encryptedClientValuesObj.clientId,
      role: encryptedClientValuesObj.role,
      email_id: clientDetails.email,
    };
    const regdataData = handleAPIEncryptValue(JSON.stringify(data));
    get(`${url}?regdata=${regdataData}`, true)
      .then((response) => {
        const {
          data: { encryptBody, statusCode, authData },
        } = response;
        setIsLoading(false);
        const finalArr = [];

        switch (statusCode) {
          case 200: {
            const iv = authData;
            const idToken = localStorage.getItem("userToken");
            const secretKey = idToken.slice(998, 1030);
            const body = handleDecryptResponse(
              encryptBody.toString(),
              secretKey.toString(),
              iv.toString(),
            );
            body.data.map((item) =>
              finalArr.push(
                item.reduce(
                  (prev, next, index) => ({
                    ...prev,
                    [body.columns[index]]: next,
                  }),
                  {},
                ),
              ),
            );
            // console.log('encrypted params clientId:',
            // handleDecryptedValue(encryptedClientValuesObj?.clientId));
            // console.log('finalArr :', finalArr);
            setFilesData(finalArr);
            setColumnData(body.columns);
            break;
          }
          case 400:
            toast.error("Error in loading data.");
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        setIsLoading(false);
      });
  };

  const handleClientDetailsEncryption = (clientData) => {
    const IdToken = localStorage.getItem("userToken");
    handleDataEncryption(
      "RegDataVal4",
      JSON.stringify(clientData),
      IdToken.slice(27, 47),
    );
  };

  const adminClientList = () => {
    const url = getUrl("get-super-admin-firm");
    setIsLoading(true);
    const data = {
      role: encryptedClientValuesObj.role,
      email_id: clientDetails.email,
    };
    const regdataData = handleAPIEncryptValue(JSON.stringify(data));
    get(`${url}?regdata=${regdataData}`, true)
      // get(
      //   `${url}?email_id=${clientDetails?.email}&role=${encryptedClientValuesObj?.role}`,
      //   true,
      // )
      .then((res) => {
        // console.log(res, '--responseSettings');
        switch (res.status) {
          case 200:
            {
              setIsLoading(false);
              const iv1 = res.data.authData;
              const secretKey = localStorage
                .getItem("userToken")
                .slice(998, 1030);
              const body1 = handleDecryptResponse(
                res.data.encryptBody.toString(),
                secretKey.toString(),
                iv1.toString(),
              );
              for (let i = 0; i < body1.data.length; i += 1) {
                optionList.push(
                  <option key={body1.data[i][1]} value={body1.data[i][0]}>
                    {body1.data[i][1]}
                  </option>,
                );
              }
              body1.data.map((item) =>
                clientidname.push(
                  item.reduce(
                    (prev, next, index) => ({
                      ...prev,
                      [body1.columns[index]]: next,
                    }),
                    {},
                  ),
                ),
              );
              setClientList(optionList);
              setClientName(clientidname);
            }
            break;
          case 400:
            toast.error("Error in loading data.");
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        setIsLoading(false);
      });
  };
  const handleLocalStorageData = (body) => {
    // console.log('body :', body);
    const IdToken = localStorage.getItem("userToken");
    localStorage.setItem("userToken", IdToken);
    handleDataEncryption(
      "RegDataVal3",
      body?.REACT_APP_INPUT_BUCKET.toString(),
      IdToken.slice(27, 47),
    );
  };

  const clientDropdownHandler = (e) => {
    // console.log(e, '----e');
    setIsLoading(true);
    let cName = "";
    let cId = e.target.value;
    for (let i = 0; i < clientName.length; i += 1) {
      // console.log(clientName[i].Firm_Id);
      if (cId === clientName[i].Firm_Id) {
        cName = clientName[i].Firm_Name;
      }
    }

    const firmSpecUrl = getUrl("get-firm-spec");
    setClientId(cId);
    const paramsObj = { cId };
    const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
    const data = {
      client_id: encryptedParamsObj.cId,
      email_id: clientDetails.email,
    };

    const regdataData = handleAPIEncryptValue(JSON.stringify(data));
    get(`${firmSpecUrl}?regdata=${regdataData}`, true).then((res) => {
      // console.log(res);
      const iv1 = res.data.authData;
      const secretKey = localStorage.getItem("userToken").slice(998, 1030);
      const body1 = handleDecryptResponse(
        res.data.encryptBody.toString(),
        secretKey.toString(),
        iv1.toString(),
      );

      // handleLocalStorageData(body1);
      let emptyList = [];
      let dict = {};
      let sortedProductsData = body1.data.sort();
      // console.log(body1, 'SPD');
      switch (res.status) {
        case 200:
          // console.log('res', res);
          for (let i = 0; i < sortedProductsData.length; i += 1) {
            let element = sortedProductsData[i];
            // console.log(element, '---Element');
            if (element[1] in dict) {
              emptyList.push(element[2]);
              dict[`${element[1]}`] = emptyList;
            } else {
              emptyList = [];
              emptyList.push(element[2]);
              dict[`${element[1]}`] = emptyList;
            }
          }
          // console.log(dict);
          // clientDetails.dataAccess = dict;
          setClientDetails((previousDetails) => ({
            ...previousDetails,
            clientId: e.target.value,
            clientName: cName,
            dataAccess: dict,
            REACT_APP_INPUT_BUCKET: body1.REACT_APP_INPUT_BUCKET,
          }));
          handleLocalStorageData(body1);
          const encryptedBucketName = localStorage.getItem("RegDataVal3");
          const rawToken = localStorage.getItem("userToken");
          const secretKey = rawToken.slice(27, 47);
          // setInputBucketName(
          //   handleDataDecryption(encryptedBucketName, secretKey.toString())
          // );
          setInputBucketName(body1.REACT_APP_INPUT_BUCKET);
          // setInputBucketName(body1.REACT_APP_INPUT_BUCKET);
          break;
        case 400:
          toast.error("Error in loading data.");
          break;
        case 401:
          toast.error("Unauthorized Access");
          break;
        default:
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
          break;
      }
    });
  };

  useEffect(() => {
    handleClientDetailsEncryption(clientDetails);
    if (Object.keys(encryptedClientValuesObj)?.length > 0) {
      getUsers();
      if (clientRole === "Admin") {
        adminClientList();
      }
    }
    const timeout = setTimeout(() => {
      setShowComponent(true);
    }, 5000);
    return () => clearTimeout(timeout);
  }, [encryptedClientValuesObj]);

  return (
    <>
      <HeaderComponent visibility={false} />
      <div className="sidebar" style={{ height: "40px" }}>
        {!isLoading && <SidePanel />}
      </div>
      <main
        className={`${isFullscreen ? "" : "middle_section"} dashboard_middle`}
      >
        <div className="container">
          <div className="dashboard_header mt-3">
            {isAuthenticated && (
              <select
                className="header-button-dropdown"
                style={{ marginTop: "20px", padding: "10px 20px" }}
                label="clientIdDropdown"
                name="clientIdDropdown"
                id="clientIdDropdown"
                onChange={(e) => clientDropdownHandler(e)}
                value={clientId}
              >
                <option value="">Select Client</option>
                {clientList}
              </select>
            )}
          </div>

          <div
            className={`dashboard_inner pt-0 ${
              isFullscreen ? "fullscreen-grid" : "mt-3"
            }`}
          >
            <div className="d-flex justify-content-end grid-icon-wrapper">
              <GridGroupIcons
                onRefresh={getUsers}
                isFullscreen={isFullscreen}
                iconsDisabled={isLoading}
                onToggleFullscreen={() => setIsFullscreen(!isFullscreen)}
                downloadIcon={false}
              />
            </div>
            <div className="rx_table_wrapper table-responsive padding-fix">
              {isLoading ? (
                <div className="text-center" style={{ height: "80vh" }}>
                  <CircularProgress size={26} sx={{ color: "black" }} />
                </div>
              ) : (
                <table className="dashboard_table text-center">
                  <thead>
                    <tr className="border_bt_none">
                      {columnData && columnData.length > 0 ? (
                        columnData.map((obj, index) => (
                          <th key={index}>{obj}</th>
                        ))
                      ) : (
                        <></>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {filesData && filesData.length > 0 ? (
                      filesData.map((obj, index) => (
                        <tr key={index}>
                          <td>{obj["FIRM ID"]}</td>
                          <td>{obj["FIRM NAME"]}</td>
                          <td>{obj["USERNAME "]}</td>
                          <td>{obj["USER FIRSTNAME"]}</td>
                          <td>{obj["USER LASTNAME"]}</td>
                          <td>{obj.ROLE}</td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr>
                          <td>
                            {/* <NoDataFoundComponent /> */}
                            {showComponent && <NoDataFoundComponent />}
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </main>
      <FooterComponent />
    </>
  );
}

export default Settings;
